var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 21.5596L13.4453 20.0596",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 0.0800781V1.03613H9.86523V0.0800781H14.0254Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4453 7.68552H9.95889C9.88797 7.24826 9.75722 6.8609 9.56664 6.52345C9.37606 6.18124 9.13894 5.89132 8.85528 5.65368C8.57163 5.41603 8.24808 5.2378 7.88465 5.11898C7.52564 4.99541 7.13783 4.93362 6.72121 4.93362C5.98105 4.93362 5.32509 5.13324 4.75335 5.53248C4.1816 5.92697 3.73396 6.50681 3.41041 7.27202C3.08686 8.03248 2.92509 8.96166 2.92509 10.0596C2.92509 11.1765 3.08686 12.1176 3.41041 12.8828C3.73839 13.6432 4.18603 14.2183 4.75335 14.608C5.32509 14.993 5.97883 15.1855 6.71456 15.1855C7.12232 15.1855 7.50348 15.1285 7.85805 15.0144C8.21706 14.8956 8.53839 14.7221 8.82204 14.494C9.11013 14.2658 9.35168 13.9854 9.5467 13.6527C9.74614 13.32 9.88354 12.9398 9.95889 12.512L12.4453 12.5263C12.3522 13.2202 12.1506 13.8714 11.8403 14.4797C11.5345 15.0881 11.1334 15.6252 10.637 16.0909C10.1406 16.552 9.55999 16.9132 8.89517 17.1746C8.23035 17.4312 7.4924 17.5596 6.68132 17.5596C5.48465 17.5596 4.4165 17.2625 3.47689 16.6684C2.53728 16.0743 1.79711 15.2164 1.25639 14.0947C0.715673 12.9731 0.445312 11.628 0.445312 10.0596C0.445312 8.48638 0.717889 7.14132 1.26304 6.0244C1.80819 4.90273 2.55058 4.04484 3.49019 3.45073C4.4298 2.85662 5.49351 2.55957 6.68132 2.55957C7.43922 2.55957 8.14393 2.67364 8.79545 2.90178C9.44697 3.12991 10.0276 3.46499 10.5373 3.907C11.047 4.34427 11.4658 4.88134 11.7938 5.51822C12.1262 6.15035 12.3434 6.87278 12.4453 7.68552Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCMinus);
export default __webpack_public_path__ + "static/media/c-minus.01a54af09641682ec0896c8183752336.svg";
export { ForwardRef as ReactComponent };